import React from 'react'
import ReactDOM from 'react-dom'
import { Route, HashRouter as Router, Redirect } from 'react-router-dom'
import 'typeface-roboto'
import './index.css'
import Dashboard from './routes/Dashboard.js'
import Event from './routes/Event'
import Ticket from './routes/Ticket'
import AllReport from './routes/AllReport'
import Vehicle from './routes/Vehicle'
import Full from './routes/Full'
import Critical from './routes/Critical'
import CheckEvent from './routes/CheckEvent'
import CheckedEvent from './routes/CheckedEvent'
import Offense from './routes/Offense'
import CheckEventByVehicle from './routes/CheckEventByVehicle'
import CheckedEventByVehicle from './routes/CheckedEventByVehicle'
import OffenseByVehicle from './routes/OffenseByVehicle'
import InProgress from './routes/InProgress'
import CheckTicket from './routes/CheckTicket'
import CheckedTicket from './routes/CheckedTicket'
import AddTicket from './routes/AddTicket'
import UploadTicket from './routes/UploadTicket'
import DashboardByVehicle from './routes/DashboardByVehicle'
import EventByVehicle from './routes/EventByVehicle'
import TicketByVehicle from './routes/TicketByVehicle'
import InProgressTicketByVehicle from './routes/InProgressTicketByVehicle'
import CheckTicketByVehicle from './routes/CheckTicketByVehicle'
import FleeetError from './routes/Error'
import CheckedTicketByVehicle from './routes/CheckedTicketByVehicle'
import * as serviceWorker from './serviceWorker'
import { ApolloProvider } from 'react-apollo'
import { client } from './graphql/client'
import Login from './components/Authentication/Login'
import HandleCode from './components/Authentication/HandleCode'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    localStorage.getItem('token') && localStorage.getItem('token') !== 'undefined'
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { referrer: window.location.href }
      }} />
  )} />
)

const routing = (
  <ApolloProvider client={client}>
    <Router>
      <div>
        <Route path='/login' component={Login} />
        <Route path='/' component={HandleCode} />
        <PrivateRoute path='/error' component={FleeetError} />
        {/* <Route path='/:product_id/dashboard' component={Dashboard} /> */}
        <PrivateRoute path='/:product_id/dashboard' component={Dashboard} />
        <PrivateRoute path='/:product_id/events' component={Event} />
        <PrivateRoute path='/:product_id/tickets' component={Ticket} />
        <PrivateRoute path='/:product_id/all-report' component={AllReport} />
        <PrivateRoute path='/:product_id/vehicle' component={Vehicle} />
        <PrivateRoute path='/:product_id/full' component={Full} />
        <PrivateRoute path='/:product_id/critival-volume' component={Critical} />
        <PrivateRoute path='/:product_id/events-to-check' component={CheckEvent} />
        <PrivateRoute path='/:product_id/checked-events' component={CheckedEvent} />
        <PrivateRoute path='/:product_id/offenses' component={Offense} />
        <PrivateRoute path='/:product_id/in-progress-tickets' component={InProgress} />
        <PrivateRoute path='/:product_id/tickets-to-ckeck' component={CheckTicket} />
        <PrivateRoute path='/:product_id/checked-tickets' component={CheckedTicket} />
        <PrivateRoute path='/:product_id/add-ticket' component={AddTicket} />
        <PrivateRoute path='/:product_id/edit-ticket' component={AddTicket} />
        <PrivateRoute path='/:product_id/upload-csv' component={UploadTicket} />
        <PrivateRoute path='/:product_id/dashboard-by-vehicle' component={DashboardByVehicle} />
        <PrivateRoute path='/:product_id/events-by-vehicle' component={EventByVehicle} />
        <PrivateRoute path='/:product_id/events-to-check-by-vehicle' component={CheckEventByVehicle} />
        <PrivateRoute path='/:product_id/checked-events-by-vehicle' component={CheckedEventByVehicle} />
        <PrivateRoute path='/:product_id/offenses-by-vehicle' component={OffenseByVehicle} />
        <PrivateRoute path='/:product_id/tickets-by-vehicle' component={TicketByVehicle} />
        <PrivateRoute path='/:product_id/in-progress-tickets-by-vehicle' component={InProgressTicketByVehicle} />
        <PrivateRoute path='/:product_id/tickets-to-ckeck-by-vehicle' component={CheckTicketByVehicle} />
        <PrivateRoute path='/:product_id/checked-tickets-by-vehicle' component={CheckedTicketByVehicle} />
      </div>
    </Router>
  </ApolloProvider>
)

ReactDOM.render(
  routing, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
